import { Parser } from "htmlparser2";

// These SDKs verify their script's canonical Google origin. An opaque srcdoc
// cannot use our service worker, so it must load the public SDK normally.
const PUBLIC_AD_SDKS = new Set([
  "https://imasdk.googleapis.com/js/sdkloader/ima3.js",
  "https://pagead2.googlesyndication.com/omsdk/releases/live/omweb-v1.js",
  "https://pagead2.googlesyndication.com/omsdk/releases/control/omweb-v1.js",
]);
const INERT_CONTEXTS = new Set([
  "template",
  "noscript",
  "svg",
  "math",
  "iframe",
  "object",
  "noembed",
  "noframes",
  "textarea",
  "title",
  "xmp",
  "plaintext",
]);

/** Only preserve public SDK documents whose actual sandbox makes them opaque. */
export function shouldPreserveOpaqueAdSdkSrcdoc(
  html: string,
  attrs?: Record<string, string | undefined>,
): boolean {
  // The DOM setter passes the current native sandbox attribute, including
  // tokens added through iframe.sandbox.add(). A saved scramjet-attr-sandbox
  // value does not describe the frame's actual current security policy.
  if (attrs?.sandbox === undefined) return false;
  const tokens = attrs.sandbox.toLowerCase().split(/[\t\n\f\r ]+/);
  if (!tokens.includes("allow-scripts") || tokens.includes("allow-same-origin"))
    return false;

  let inertDepth = 0;
  let foundSdk = false;
  const parser = new Parser({
    onopentag(name, attributes) {
      if (INERT_CONTEXTS.has(name)) inertDepth++;
      if (inertDepth || name !== "script") return;
      const type = attributes.type?.trim().toLowerCase() ?? "";
      if (
        ![
          "",
          "text/javascript",
          "application/javascript",
          "application/x-javascript",
        ].includes(type) ||
        attributes.nomodule !== undefined
      )
        return;
      if (PUBLIC_AD_SDKS.has(attributes.src?.trim() ?? "")) foundSdk = true;
    },
    onclosetag(name) {
      if (INERT_CONTEXTS.has(name)) inertDepth--;
    },
  });
  try {
    parser.end(html);
  } catch {
    return false;
  }
  return foundSdk;
}
